import { faQuestionCircle } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { Box, FormControlLabel, IconButton, Switch, Tooltip, Typography, useTheme } from "@mui/material"
import CompanyDepartmentSelection from "components/CompanyDepartmentSelection/CompanyDepartmentSelection"
import { useTranslation } from "react-i18next"

const explain_admin_filter =
  "As an administrator, you can also apply filters to companies not assigned to your user"

const FilterForm = ({
  onChange,
  setState,
  state,
  showShowAll,
  companies,
  showAllCompanies,
  setShowAllCompanies
}) => {
  const { t } = useTranslation("translation")
  const theme = useTheme()

  return (
    <Box flexDirection="horizontal" mt={2}>
      <Typography variant="caption" gutterBottom>
        {t("settings.user.company_and_departments", "Companies and departments")}
      </Typography>
      {showShowAll ? (
        <Box>
          <FormControlLabel
            control={
              <Switch
                sx={{ mt: 1 }}
                onChange={(event) => {
                  const checked = event.target.checked
                  setShowAllCompanies(checked)
                }}
                id="showAllCompanies"
                checked={showAllCompanies}
              />
            }
            label={t("news.filter_by_company", "Filter by company")}
          />
          <Tooltip title={t("news.explain_admin_filter_company", explain_admin_filter)}>
            <IconButton size="small" sx={{ color: theme.palette.primary[700] }}>
              <FontAwesomeIcon icon={faQuestionCircle} />
            </IconButton>
          </Tooltip>
        </Box>
      ) : null}
      <CompanyDepartmentSelection
        //key={companies} // component will rerender whenever key changes
        companies={companies} // only state causes component to rerender, not props
        initCompanies={state.companyIds}
        initDepartments={state.departmentIds}
        onChange={(newState) => {
          const companyIds = []
          const departmentIds = []

          newState.forEach((c) => {
            if (c.selected) companyIds.push(c.id)
            c.departments.forEach((d) => {
              if (d.selected) departmentIds.push(d.id)
            })
          })

          setState((s) => {
            return {
              ...s,
              companyIds,
              departmentIds
            }
          })
          onChange({
            ...state,
            companyIds,
            departmentIds
          })
        }}
      />
    </Box>
  )
}

export default FilterForm
